import {
  takeEvery,
  put,
  call
} from 'redux-saga/effects';
import {
  getFakeDataList
} from '../../test-apis/fakeapi';
import {
  getTestDataSuccess,
  apiError
} from './actions';
import {
  GET_TEST_DATA
} from './actionTypes';

function* getTestData({
  payload: params
}) {
  try {
    // params.delay, params.isError 는 테스트용
    const response = yield call(getFakeDataList, params, params.delay, params.error);
    yield put(getTestDataSuccess(response));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* TaskSaga() {
  yield takeEvery(GET_TEST_DATA, getTestData)
}

export default TaskSaga;